
<modal :state="state" :index="index" @toggle-modal="hideOrReturn" :should-cancel-on="!isSaving">
  <div class="organization-modal" :slot="ModalStatus.Confirmation">
    <h3 class="modal-title">Create organization</h3>

    <flash-attribute-messages v-if="errors" :messages="errors"></flash-attribute-messages>

    <div>
      <div>
        <label for="organization-name">Name organization</label>
        <input id="organization-name" type="text" v-model="name" @keydown.enter="createOrg">
      </div>

      <div>
        <label for="organization-subdomain">Subdomain</label>
        <row class="component-row">
          <column>
            <input id="organization-subdomain" class="align-right" type="text" v-model="subdomain" @keydown.enter="createOrg">
          </column>
          <suffix>
            <pencil color="Inherit">.Formability.com</pencil>
          </suffix>
        </row>
      </div>
    </div>

    <div class="cta">
      <button type="button" class="btn red outline block" data-dismiss="modal" @click="hideOrReturn" :disabled="isSaving">Cancel</button>
      <button type="button" class="btn green block"
              @click="createOrg"
              :disabled="!isValidOrganization || isSaving">
        Create
      </button>
    </div>
  </div>
  <div :slot="ModalStatus.InProgress">
    <h3 class="modal-title">Creating organization...</h3>
    <p>This will take just a second.</p>
  </div>
</modal>
